/**
 * HydroJug Bundle Landing Page JavaScript
 * Handles: product selectors, dynamic pricing, multi-item AJAX cart,
 *          smooth scroll, cart drawer, Shopify editor support
 */
(function() {
  'use strict';

  /* ========================================
     Utility: format cents to currency
     ======================================== */
  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  /* ========================================
     Smooth Scroll for Anchor Links
     ======================================== */
  function initSmoothScroll() {
    var links = document.querySelectorAll('a[href^="#hjblp-"]');
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var targetId = this.getAttribute('href');
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ========================================
     Product Selectors — Dropdown Logic
     ======================================== */
  function closeAllDropdowns(except) {
    var selectors = document.querySelectorAll('.hjblp-tier__selector.is-open');
    selectors.forEach(function(sel) {
      if (sel !== except) {
        sel.classList.remove('is-open');
        var dd = sel.querySelector('.hjblp-tier__selector-dropdown');
        if (dd) dd.hidden = true;
        var toggle = sel.querySelector('.hjblp-tier__selector-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function updateToggleDisplay(selectorEl, option) {
    var img = selectorEl.querySelector('.hjblp-tier__selector-img');
    var chosen = selectorEl.querySelector('.hjblp-tier__selector-chosen');
    if (img && option.dataset.image) {
      img.src = option.dataset.image;
      img.alt = option.dataset.title || '';
    }
    if (chosen) {
      chosen.textContent = option.dataset.title || '';
    }
  }

  function recalcTierPricing(tierEl) {
    var discount = parseInt(tierEl.dataset.discount, 10) || 0;
    var selectors = tierEl.querySelectorAll('[data-selector]');
    var totalCents = 0;
    var allSelected = true;

    selectors.forEach(function(sel) {
      var selected = sel.querySelector('.hjblp-tier__selector-option.is-selected');
      if (selected) {
        totalCents += parseInt(selected.dataset.price, 10) || 0;
      } else {
        allSelected = false;
      }
    });

    if (totalCents > 0) {
      var saveCents = Math.round(totalCents * discount / 100);
      var bundleCents = totalCents - saveCents;

      var priceEl = tierEl.querySelector('[data-tier-price]');
      var origEl = tierEl.querySelector('[data-tier-original]');
      if (priceEl) priceEl.textContent = formatMoney(bundleCents);
      if (origEl) origEl.textContent = formatMoney(totalCents);

      /* Update comparison section if this is the featured tier */
      if (tierEl.hasAttribute('data-featured')) {
        var section = tierEl.closest('.hjblp-content');
        if (section) {
          var compOrig = section.querySelector('[data-compare-original]');
          var compBundle = section.querySelector('[data-compare-bundle]');
          var compSave = section.querySelector('[data-compare-save]');
          if (compOrig) compOrig.textContent = formatMoney(totalCents);
          if (compBundle) compBundle.textContent = formatMoney(bundleCents);
          if (compSave) compSave.textContent = 'You save ' + formatMoney(saveCents);
        }
      }
    }
  }

  function initProductSelectors() {
    var selectors = document.querySelectorAll('.hjblp-tier__selector');

    selectors.forEach(function(selectorEl) {
      var toggle = selectorEl.querySelector('.hjblp-tier__selector-toggle');
      var dropdown = selectorEl.querySelector('.hjblp-tier__selector-dropdown');
      if (!toggle || !dropdown) return;

      /* Toggle open/close */
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = selectorEl.classList.contains('is-open');

        closeAllDropdowns();

        if (!isOpen) {
          selectorEl.classList.add('is-open');
          dropdown.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      /* Option selection */
      var options = dropdown.querySelectorAll('.hjblp-tier__selector-option');
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          /* Update selection state */
          options.forEach(function(o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-selected', 'false');
          });
          option.classList.add('is-selected');
          option.setAttribute('aria-selected', 'true');

          /* Update toggle display */
          updateToggleDisplay(selectorEl, option);

          /* Close dropdown */
          selectorEl.classList.remove('is-open');
          dropdown.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');

          /* Recalculate tier pricing */
          var tierEl = selectorEl.closest('.hjblp-tier');
          if (tierEl) recalcTierPricing(tierEl);
        });
      });
    });

    /* Close dropdowns on outside click */
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.hjblp-tier__selector')) {
        closeAllDropdowns();
      }
    });

    /* Keyboard: ESC closes dropdowns */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAllDropdowns();
      }
    });
  }

  /* ========================================
     Add to Cart (Multi-item AJAX)
     ======================================== */
  function initAddToCart() {
    var buttons = document.querySelectorAll('[data-bundle-add]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var tierEl = btn.closest('.hjblp-tier');
        if (!tierEl) return;

        /* Collect all selected variant IDs from this tier's selectors */
        var selectors = tierEl.querySelectorAll('[data-selector]');
        var items = [];
        var allSelected = true;

        selectors.forEach(function(sel) {
          var selected = sel.querySelector('.hjblp-tier__selector-option.is-selected');
          if (selected && selected.dataset.variantId) {
            items.push({
              id: parseInt(selected.dataset.variantId, 10),
              quantity: 1
            });
          } else {
            allSelected = false;
          }
        });

        if (!allSelected || items.length === 0) {
          /* Highlight unselected items */
          selectors.forEach(function(sel) {
            var selected = sel.querySelector('.hjblp-tier__selector-option.is-selected');
            if (!selected) {
              sel.classList.add('hjblp-tier__selector--error');
              setTimeout(function() {
                sel.classList.remove('hjblp-tier__selector--error');
              }, 2000);
            }
          });
          return;
        }

        var originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.style.pointerEvents = 'none';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart error');
          return r.json();
        })
        .then(function() {
          btn.textContent = 'Added \u2713';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.pointerEvents = '';
          }, 2000);

          /* Refresh cart and open cart drawer */
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          }
        })
        .catch(function() {
          btn.textContent = 'Error — try again';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.pointerEvents = '';
          }, 2500);
        });
      });
    });
  }

  /* ========================================
     Initialization
     ======================================== */
  function init() {
    initSmoothScroll();
    initProductSelectors();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor support */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.classList.contains('section-hj-bundle-lp-content') ||
          event.target.classList.contains('section-hj-bundle-lp-hero') ||
          event.target.classList.contains('section-hj-bundle-lp-reviews')) {
        init();
      }
    });
  }
})();
